import React from 'react';
import '../../styles/search/SearchPage.css';
import SearchResult from './SearchResult';
import RoomIcon from '@material-ui/icons/Room';

function SearchPage() {
  return (
    <div className="searchPage">
      
      <div className="searchPage__info">
        <h1>
          <RoomIcon /> Estancias cercanas a ti
        </h1>
      </div>

      <SearchResult
        image="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcQ_wbPYTxQPMcBh7SPzLFActXnP3uhifeVT_g&usqp=CAU"
        location="Habitación privada en el centro de Lima"
        title="Hospédate en esta espaciosa casa"
        description="1 huésped · 1 dormitorio · 1 cama · 1.5 baños compartidos · WiFi · Cocina · Estacionamiento gratuito · Lavadora"
        star={4.73}
        price={30}
        total={117}
      />

      <SearchResult
        image="https://www.expatkings.com/wp-content/uploads/2018/10/Airbnb-rental-tips.-Hostmaker-1-620x349.jpg"
        location="Habitación privada en el centro de Arequipa"
        title="Estudio independiente"
        description="2 huéspedes · 3 habitaciones · 1 cama · 1.5 cuartos compartidos · WiFi · Cocina"
        star={4.3}
        price={40}
        total={157}
      />

      <SearchResult
        image="https://www.smartertravel.com/uploads/2017/07/Untitled-design-8.jpg"
        location="Habitación privada en el centro de Piura"
        title="Apartamentos Estudio Londres"
        description="4 huéspedes · 4 habitacion(es) · 4 cama · 2 bathrooms · Estacionamiento gratis · Lavadora"
        star={3.8}
        price={35}
        total={207}
      />
      <SearchResult
        image="https://media.cntraveler.com/photos/5a8f258bd363c34048b35aac/master/w_2250,h_1500,c_limit/airbnb-plus-london.jpg"
        location="Habitación privada en el centro de Iquitos"
        title="Dormitorio moderno espacioso y tranquilo"
        description="3 huéspedes · 1 habitacion(es) · 1 cama · 1 baño compartido · WiFi · Estacionamiento gratis · Limpieza en seco"
        star={5.0}
        price={60}
        total={450}
      />
      <SearchResult
        image="https://static.trip101.com/paragraph_media/pictures/001/676/061/large/969ae4bb-efd1-4fb9-a4e3-5cb3316dd3c9.jpg?1562227937"
        location="Habitación privada en el centro de Chiclayo"
        title="La habitación azul en Londres"
        description="2 huéspedes · 1 habitacion(es) · 1 cama · 1 baño compartido · WiFi · Lavadora"
        star={4.23}
        price={65}
        total={480}
      />
      <SearchResult
        image="https://image.insider.com/585029a0dd0895bc548b4b8b?width=750&format=jpeg"
        location="Habitación privada en el centro de Ica"
        title="Apartamento de lujo de 5 estrellas"
        description="3 huéspedes · 1 habitacion(es) · 1 cama · 1 baño compartido · WiFi · Kitchen · Estacionamiento gratis · Lavadora"
        star={3.85}
        price={90}
        total={650}
      />
    </div>
  );
}

export default SearchPage;
